module.exports = __webpack_public_path__ + "img/United States of America (USA).0f219fa7.svg";